import { generatePath } from 'react-router-dom'

import { Auth } from '@scouts/auth'
import { font, ButtonLink, Container, Line } from '@taxfix/scouts-ui'

import { PATH_COMPANY_OFFICER_EMAIL_REFERRAL_CONNECT } from '@/constants'

import { CompanyOfficerAuthContainer } from './CompanyOfficerAuthContainer'

export const CompanyOfficerAuthLogin = ({ onClickSignUp }: { onClickSignUp: VoidFunction }) => {
    const redirectPath = `${generatePath(PATH_COMPANY_OFFICER_EMAIL_REFERRAL_CONNECT)}?` // @TODO: Add query params (eg: companyKYCReferralId)

    const footer = (
        <Line size={font.small}>
            Don't have an account? <ButtonLink onClick={onClickSignUp}>Sign up here</ButtonLink>
        </Line>
    )

    return (
        <Container relative>
            <CompanyOfficerAuthContainer footer={footer}>
                <Auth.LoginForm.Compact redirectPath={redirectPath} />
            </CompanyOfficerAuthContainer>
        </Container>
    )
}
